const constantsTranslation = {
  'const.order.ratings.horrible': 'Muito Ruim',
  'const.order.ratings.bad': 'Ruim',
  'const.order.ratings.normal': 'Normal',
  'const.order.ratings.good': 'Bom',
  'const.order.ratings.amazing': 'Excelente',
};

export default constantsTranslation;
